<script setup>
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { toRef } from 'vue';
import useDataStore from '@/stores/data';
import {
  session,
  // tempConfig,
} from '@/utils/postmonger';
import useComponentsStore from '@/stores/components';
import { useRoute } from 'vue-router';

const props = defineProps({
  isSaveButtonVisible: {
    type: Boolean,
    default: false,
  },
});

const isSaveButtonVisible = toRef(() => props.isSaveButtonVisible);
const { t } = useI18n();
const route = useRoute();
const {
  setLoading,
} = useDataStore();
const {
  messageActivityName,
  loading,
} = storeToRefs(useDataStore());
const { openConfirmDialog } = useComponentsStore();

const exitEvent = async (event) => {
  const confirmPaths = [
    '/message',
    '/kakao',
    '/alimtalk',
    '/brand',
  ];

  event.stopImmediatePropagation();
  event.target.dispatchEvent(new Event('close-mentionList'));

  if (confirmPaths.includes(route.path)) {
    const result = await openConfirmDialog({
      activator: event.currentTarget,
      title: t('alert.discard.title'),
      content: t('alert.discard.content'),
      cancel: t('alert.discard.cancel'),
      ok: t('button.exit'),
    }).promise;

    if (!result) {
      return;
    }

    window?.onbeforeunload?.();
    session.trigger('setActivityDirtyState', false);
    session.trigger('requestInspectorClose');
    return;
  }

  session.trigger('setActivityDirtyState', false);
  session.trigger('requestInspectorClose');
};

const saveEvent = (event) => {
  if (!isSaveButtonVisible.value) {
    return;
  }

  setLoading(true);
  const customEvent = new CustomEvent('save-activity', { data: event });
  window.dispatchEvent(customEvent);
};

</script>
<template>
  <div class="header">
    <div class="header__head">
      <div class="header__logo"></div>
      <h1 class="header__name">{{ messageActivityName }}</h1>
    </div>
    <div class="header__buttons">
      <v-btn
        class="custom__button custom__button--brand-outline"
        :loading="loading"
        @click="exitEvent"
      >
        {{ t('button.exit') }}
      </v-btn>
      <v-btn
        class="custom__button custom__button--brand"
        :class="{ 'd-none': !isSaveButtonVisible }"
        prepend-icon="mdi-check"
        :loading="loading"
        @click="saveEvent"
      >
        {{ t('button.save') }}
      </v-btn>
    </div>
  </div>
</template>
